import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import PublicFooter from "../../containers/Public/PublicFooter";
import regexConfig from "../../config/regex-config";
import { forgotPassword } from "../../http/http-calls";
import { showToast } from "../../helper-methods";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  //state
  const [formData, setFormData] = useState({
    handle: "",
  });
  const [isDirty, setIsDirty] = useState({
    handle: false,
  });
  const [errors, setErrors] = useState({});

  //forgot password handler
  const _handelOnSubmit = async () => {
    // event.preventDefault();
    const newIsDirty = { ...isDirty };
    Object.keys(isDirty).forEach((each) => (newIsDirty[each] = true));
    const error = _validateForm(formData, newIsDirty);
    console.log("errors => ", error);
    if (!error) {
      console.log("no error");
      //api call
      console.log("data", formData);
      try {
        const res = await forgotPassword(formData);
        console.log("res>>", res);
        showToast("Please check your mail for reset password link", "success");
        navigate("/login");
      } catch (error) {
        console.log(error);
        showToast(error.reason, "error");
      }
    }
  };

  // On Change

  const _handelOnChange = (field, event) => {
    const newFormData = { ...formData };
    const newIsDirty = { ...isDirty };
    newFormData[field] = event.target.value;
    newIsDirty[field] = true;
    setFormData(newFormData);
    setIsDirty(newIsDirty);
    _validateForm(newFormData, newIsDirty);
  };

  //validation form
  const _validateForm = (data, dirties) => {
    const newErrors = { ...errors };

    Object.keys(dirties).forEach((each) => {
      if (each === "handle" && dirties[each]) {
        if (!data.handle.trim()) {
          newErrors.handle = "*Required";
        } else if (
          data.handle.trim().length &&
          !new RegExp(regexConfig.email).test(data.handle)
        ) {
          newErrors.handle = "*Please enter a valid email ID";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      }
    });
    setIsDirty(dirties);
    setErrors(newErrors);
    return Object.keys(newErrors).length ? true : false;
  };

  return (
    <>
      <div className="authWrapper">
        <div className="loginWrap">
          <img
            src={require("../../assets/img/company-logo.png")}
            alt="Brand Logo"
            className="companyLogo"
          />

          <Form>
            <h2>Forgot Password</h2>

            {/* username */}
            <FormGroup>
              <Label>Email</Label>
              <InputGroup>
                <Input
                  placeholder="Enter the email"
                  onChange={(event) => _handelOnChange("handle", event)}
                />
                <InputGroupText>
                  <i className="far fa-envelope"></i>
                </InputGroupText>
              </InputGroup>

              {/* show this when you get any error */}
              {errors.handle ? (
                <div className="form-error">{errors.handle}</div>
              ) : null}
            </FormGroup>

            {/* submit button */}
            <Button
              onClick={() => _handelOnSubmit()}
              color="primary"
              className="btn-submit"
            >
              Forgot Password
            </Button>

            {/*infoText*/}
            <div className="text-center fs-16 mt-3">
              Back to{" "}
              <Link to="/login" style={{ textDecoration: "underline" }}>
                Login
              </Link>
            </div>
          </Form>
        </div>

        <PublicFooter />
      </div>
    </>
  );
};

export default ForgotPasswordPage;
